(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var reviewBlockSelector = 'div[id*="judge_me_reviews_featured_carousel"].shopify-app-block';
    var reviewCtaSelector = reviewBlockSelector + ' .jdgm-carousel-number-of-reviews';
    var reviewScoreSelector = reviewBlockSelector + ' .jdgm-all-reviews-rating';
    var reviewCta = document.querySelector(reviewCtaSelector);

    if (!reviewCta) return;

    if (reviewCta.dataset.auroreReviewsLink !== 'true') {
      reviewCta.dataset.auroreReviewsLink = 'true';
      reviewCta.setAttribute('role', 'link');
      reviewCta.setAttribute('tabindex', '0');
      // Visible text ("from N reviews") is the accessible name; a separate
      // aria-label would mismatch the visible label (WCAG 2.5.3).
      reviewCta.removeAttribute('aria-label');

      var openReviewsPage = function () {
        window.location.href = '/pages/reviews';
      };

      reviewCta.addEventListener('click', openReviewsPage);
      reviewCta.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openReviewsPage();
      });
    }

    if (reviewCta.dataset.auroreLiveCountSynced === 'true') return;
    reviewCta.dataset.auroreLiveCountSynced = 'true';

    var applyHomepageReviewSummary = function (liveCount, liveScore) {
      document.querySelectorAll(reviewCtaSelector).forEach(function (node) {
        node.setAttribute('data-number-of-reviews', liveCount);
        node.textContent = 'from ' + liveCount + ' reviews';
      });

      document.querySelectorAll(reviewScoreSelector).forEach(function (node) {
        if (!liveScore) return;
        node.setAttribute('data-score', liveScore);
        node.setAttribute('aria-label', liveScore + ' stars');
      });
    };

    // Pull the live count/score out of the reviews page HTML by scanning the
    // string for the summary markers, rather than building the entire page into
    // a DOM with DOMParser. The previous full-document parse cost >1s of
    // main-thread time and was run on a 12x/second polling loop.
    var extractSummary = function (html) {
      var grab = function (className) {
        var marker = html.indexOf(className);
        if (marker === -1) return '';
        var gt = html.indexOf('>', marker);
        if (gt === -1) return '';
        var lt = html.indexOf('<', gt);
        var inner = html.slice(gt + 1, lt === -1 ? gt + 1 + 200 : lt);
        return inner.replace(/\s+/g, ' ').trim();
      };
      var countMatch = grab('aur-reviews-summary__count').match(/\d[\d,]*/);
      if (!countMatch) return null;
      return { count: countMatch[0], score: grab('aur-reviews-summary__score') };
    };

    var synced = false;
    var inFlight = false;

    var syncHomepageReviewSummary = function (onDone) {
      if (synced || inFlight) {
        if (typeof onDone === 'function') onDone();
        return;
      }
      inFlight = true;
      fetch('/pages/reviews', { credentials: 'same-origin' })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var summary = extractSummary(html);
          if (summary) {
            synced = true;
            applyHomepageReviewSummary(summary.count, summary.score);
          }
        })
        .catch(function () {
          // Keep the app-provided content when the reviews page cannot be fetched.
        })
        .then(function () {
          inFlight = false;
          if (typeof onDone === 'function') onDone();
        });
    };

    // Try immediately, then retry only while we still have no live count.
    // Stops the moment the count is found instead of polling a fixed 12 times.
    var attempts = 0;
    var attemptSync = function () {
      if (synced) return;
      attempts += 1;
      syncHomepageReviewSummary(function () {
        if (synced || attempts >= 5) return;
        window.setTimeout(attemptSync, 1000);
      });
    };
    attemptSync();

    // If Judge.me injects/updates the block after load, sync once more — but
    // only while unsynced, and disconnect as soon as we have the count.
    var reviewBlock = document.querySelector(reviewBlockSelector);
    if (reviewBlock) {
      var observer = new MutationObserver(function () {
        if (synced) { observer.disconnect(); return; }
        syncHomepageReviewSummary();
      });
      observer.observe(reviewBlock, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-number-of-reviews', 'data-score']
      });
      window.setTimeout(function () { observer.disconnect(); }, 15000);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname !== '/pages/reviews') return;

    var ensureJudgeMeYtInputShim = function () {
      if (!window.jdgm) return false;
      if (typeof window.jdgm._setupYtInput !== 'function') {
        window.jdgm._setupYtInput = function () {};
      }
      return true;
    };

    if (!ensureJudgeMeYtInputShim()) {
      var judgeMeShimAttempts = 0;
      var judgeMeShimTimer = window.setInterval(function () {
        judgeMeShimAttempts += 1;
        if (ensureJudgeMeYtInputShim() || judgeMeShimAttempts > 40) {
          window.clearInterval(judgeMeShimTimer);
        }
      }, 100);
    }

    var resetJudgeMeReviewTrigger = function (source) {
      if (!source) return;
      source.querySelectorAll('.jdgm-write-rev-link').forEach(function (trigger) {
        trigger.classList.remove('close-form-btn');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.textContent = trigger.textContent && trigger.textContent.toLowerCase().includes('store')
          ? 'Write a Store Review'
          : 'Write a review';
        if (trigger.style) trigger.style.display = '';
      });
    };

    var resetAuroreReviewForm = function (source) {
      if (!source) return;

      if (window.jdgm && window.jdgm._setupFormsSubmitCache) {
        window.jdgm._setupFormsSubmitCache = {};
      }

      source.querySelectorAll('.jdgm-submit-rev').forEach(function (button) {
        button.disabled = false;
        button.removeAttribute('disabled');
      });

      source.querySelectorAll('.jdgm-input-error, .error').forEach(function (element) {
        element.classList.remove('jdgm-input-error', 'error');
        element.removeAttribute('aria-invalid');
      });

      source.querySelectorAll('div[id$="-error"], label[id$="-error"], #score-error').forEach(function (element) {
        element.remove();
      });

      source.querySelectorAll('input:not([type="hidden"]):not([type="file"]):not([type="submit"]), textarea').forEach(function (field) {
        field.value = '';
      });

      source.querySelectorAll('input[name="score"]').forEach(function (field) {
        field.removeAttribute('value');
        field.value = '';
      });

      source.querySelectorAll('.jdgm-form__rating .jdgm-star').forEach(function (star) {
        star.classList.remove('jdgm--on', 'jdgm--half');
        star.classList.add('jdgm--off');
      });

      source.querySelectorAll('.jdgm-countdown').forEach(function (counter) {
        counter.textContent = '';
        counter.style.display = 'none';
      });
    };

    var normalizeAuroreReviewForm = function (source) {
      if (!source) return;

      source.querySelectorAll('.jdgm-form-wrapper').forEach(function (wrapper) {
        wrapper.style.display = 'block';
        wrapper.style.height = 'auto';
        wrapper.style.overflow = 'hidden';
      });

      source.querySelectorAll('.jdgm-form__title').forEach(function (title) {
        var normalizedText = title.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
        if (normalizedText === 'write a review') title.textContent = 'Write a Review';
        if (normalizedText === 'rating') title.textContent = 'YOUR RATING';
        if (normalizedText === 'review title') title.textContent = 'REVIEW TITLE';
        if (normalizedText === 'review content') title.textContent = 'REVIEW CONTENT';
        if (normalizedText === 'picture/video (optional)') title.textContent = 'PHOTO/VIDEO OPTIONAL';
        if (normalizedText.indexOf('display name') !== -1) title.textContent = 'NAME';
        if (normalizedText === 'email address') title.textContent = 'EMAIL';
      });

      source.querySelectorAll('input[name="review_title"]').forEach(function (input) {
        input.setAttribute('placeholder', 'Summarize your experience...');
      });
      source.querySelectorAll('textarea[name="review_body"]').forEach(function (textarea) {
        textarea.setAttribute('placeholder', "Tell us about the quality, fit, and how you're wearing it...");
      });
      source.querySelectorAll('input[name="reviewer_name"]').forEach(function (input) {
        input.setAttribute('placeholder', 'First name + last initial');
      });
      source.querySelectorAll('input[name="reviewer_email"]').forEach(function (input) {
        input.setAttribute('placeholder', 'For verification only');
      });
      source.querySelectorAll('input[name="yt_url"], input[data-aurore-yt-url-name]').forEach(function (input) {
        input.value = '';
        input.disabled = true;
        input.dataset.auroreYtUrlName = 'yt_url';
        input.removeAttribute('name');
        input.setAttribute('aria-hidden', 'true');
        input.setAttribute('tabindex', '-1');
      });
      source.querySelectorAll('.jdgm-cancel-rev').forEach(function (button) {
        button.setAttribute('aria-label', 'Close review form');
        if ('value' in button) button.value = '×';
        button.textContent = '×';
      });
    };

    var clearAuroreReviewSubmitStatus = function (source) {
      if (!source) return;
      source.querySelectorAll('[data-aurore-review-submit-status]').forEach(function (status) { status.remove(); });
    };

    var showAuroreReviewSubmitStatus = function (source, message, type) {
      if (!source || !message) return;

      clearAuroreReviewSubmitStatus(source);

      var form = source.querySelector('.jdgm-form-wrapper:has(.jdgm-submit-rev) .jdgm-form');
      if (!form) return;

      var status = document.createElement('div');
      status.className = 'aur-review-submit-status aur-review-submit-status--' + (type || 'info');
      status.dataset.auroreReviewSubmitStatus = 'true';
      status.setAttribute('role', type === 'error' ? 'alert' : 'status');
      status.textContent = message;

      var title = form.querySelector(':scope > .jdgm-form__title:first-child');
      if (title && title.nextSibling) {
        form.insertBefore(status, title.nextSibling);
      } else {
        form.prepend(status);
      }
    };

    var reenableAuroreReviewSubmit = function (source) {
      if (!source) return;
      if (window.jdgm && window.jdgm._setupFormsSubmitCache) {
        window.jdgm._setupFormsSubmitCache = {};
      }
      source.querySelectorAll('.jdgm-submit-rev').forEach(function (button) {
        button.disabled = false;
        button.removeAttribute('disabled');
      });
    };

    var setupAuroreJudgeMeSubmitFeedback = function () {
      if (window.auroreJudgeMeSubmitFeedbackReady || !(window.jdgm && window.jdgm.$)) return;

      window.auroreJudgeMeSubmitFeedbackReady = true;
      window.jdgm.$(document)
        .on('ajaxSuccess.auroreReviews', function (_event, _xhr, settings) {
          if (!(settings && settings.url) || settings.url.indexOf('/api/v1/reviews') === -1) return;

          var source = document.querySelector('.aur-judgeme-functional-source.is-open');
          if (!source) return;

          reenableAuroreReviewSubmit(source);
          showAuroreReviewSubmitStatus(
            source,
            'Thank you. Your review was submitted and will appear after verification.',
            'success'
          );
        })
        .on('ajaxError.auroreReviews', function (_event, _xhr, settings) {
          if (!(settings && settings.url) || settings.url.indexOf('/api/v1/reviews') === -1) return;

          var source = document.querySelector('.aur-judgeme-functional-source.is-open');
          if (!source) return;

          reenableAuroreReviewSubmit(source);
          showAuroreReviewSubmitStatus(
            source,
            'We could not submit your review. Please check the fields and try again.',
            'error'
          );
        });
    };

    var closeAuroreReviewModal = function () {
      var source = document.querySelector('.aur-judgeme-functional-source');
      if (!source) return;
      var widget = source.querySelector('.jdgm-all-reviews-widget');
      if (window.jdgm && window.jdgm.closeForm && window.jdgm.$ && widget) {
        window.jdgm.closeForm(window.jdgm.$(widget));
      }
      resetAuroreReviewForm(source);
      clearAuroreReviewSubmitStatus(source);
      resetJudgeMeReviewTrigger(source);
      source.querySelectorAll('.jdgm-form-wrapper').forEach(function (wrapper) {
        wrapper.style.display = 'none';
        wrapper.style.height = 'auto';
        wrapper.style.overflow = 'hidden';
      });
      source.classList.remove('is-open');
    };

    document.addEventListener('click', function (event) {
      var closeButton = event.target.closest('.aur-judgeme-functional-source .jdgm-cancel-rev');
      if (closeButton) {
        event.preventDefault();
        event.stopPropagation();
        closeAuroreReviewModal();
        return;
      }

      var reviewOverlay = event.target.closest('.aur-judgeme-functional-source');
      if (
        reviewOverlay &&
        reviewOverlay.querySelector('.jdgm-form-wrapper') &&
        !event.target.closest('.jdgm-form-wrapper')
      ) {
        event.preventDefault();
        event.stopPropagation();
        closeAuroreReviewModal();
        return;
      }

      var customWriteReviewButton = event.target.closest('[data-aurore-write-review]');
      if (!customWriteReviewButton) return;

      event.preventDefault();
      event.stopPropagation();

      setupAuroreJudgeMeSubmitFeedback();

      var judgeMeTrigger =
        document.querySelector('.aur-judgeme-functional-source .jdgm-write-rev-link') ||
        document.querySelector('body.page-reviews [data-testid="write-review-button"]') ||
        document.querySelector('body.page-reviews .jm-action-buttons__button[data-testid="write-review-button"]') ||
        document.querySelector('body.page-reviews .jdgm-btn.jdgm-write-rev-link') ||
        document.querySelector('body.page-reviews .jdgm-write-rev-link.jdgm-write-rev-link--review-widget') ||
        document.querySelector('body.page-reviews .jdgm-write-rev-link') ||
        document.querySelector('body.page-reviews [data-write-review]');

      if (judgeMeTrigger) {
        var source = document.querySelector('.aur-judgeme-functional-source');
        var widget = source && source.querySelector('.jdgm-all-reviews-widget');
        resetJudgeMeReviewTrigger(source);
        clearAuroreReviewSubmitStatus(source);
        if (source) source.classList.add('is-open');
        if (judgeMeTrigger.style) judgeMeTrigger.style.display = '';
        if (source && source.querySelector('.jdgm-form-wrapper') && window.jdgm && window.jdgm.openForm && window.jdgm.$ && widget) {
          resetAuroreReviewForm(source);
          window.jdgm.openForm(window.jdgm.$(widget));
          normalizeAuroreReviewForm(source);
        } else {
          judgeMeTrigger.click();
        }
        window.setTimeout(function () {
          normalizeAuroreReviewForm(document.querySelector('.aur-judgeme-functional-source'));
        }, 160);
        return;
      }

      console.warn('Judge.me write review trigger not found.');
    });

    document.addEventListener('submit', function (event) {
      var formWrapper = event.target.closest && event.target.closest('.aur-judgeme-functional-source .jdgm-form-wrapper');
      if (!formWrapper) return;
      var source = formWrapper.closest('.aur-judgeme-functional-source');
      clearAuroreReviewSubmitStatus(source);
      setupAuroreJudgeMeSubmitFeedback();
    }, true);

    var getAuroreReviewCards = function () { return Array.from(document.querySelectorAll('[data-review-card]')); };
    var activeReviewFilter = '5';
    var activeCategoryFilter = 'all';

    var setActiveButtons = function (selector, value, attribute) {
      document.querySelectorAll(selector).forEach(function (button) {
        button.classList.toggle('is-active', button.getAttribute(attribute) === value);
      });
    };

    var applyAuroreReviewFilters = function () {
      var cards = getAuroreReviewCards();
      var empty = document.querySelector('[data-review-empty]');
      var visibleCount = 0;

      cards.forEach(function (card) {
        var rating = Number(card.dataset.rating || 0);
        var matchesReviewFilter =
          activeReviewFilter === 'all' ||
          (activeReviewFilter === 'verified' && card.dataset.verified === 'true') ||
          (activeReviewFilter === 'photos' && card.dataset.photos === 'true') ||
          (!Number.isNaN(Number(activeReviewFilter)) && rating === Number(activeReviewFilter));
        var matchesCategoryFilter = activeCategoryFilter === 'all' || card.dataset.category === activeCategoryFilter;
        var isVisible = matchesReviewFilter && matchesCategoryFilter;

        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (empty) empty.hidden = visibleCount !== 0;
    };

    document.querySelectorAll('[data-review-filter]').forEach(function (button) {
      button.addEventListener('click', function () {
        activeReviewFilter = button.dataset.reviewFilter || 'all';
        setActiveButtons('[data-review-filter]', activeReviewFilter, 'data-review-filter');
        applyAuroreReviewFilters();
      });
    });

    document.querySelectorAll('[data-category-filter]').forEach(function (button) {
      button.addEventListener('click', function () {
        activeCategoryFilter = button.dataset.categoryFilter || 'all';
        setActiveButtons('[data-category-filter]', activeCategoryFilter, 'data-category-filter');
        applyAuroreReviewFilters();
      });
    });

    var sortSelect = document.querySelector('[data-review-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function (event) {
        var grid = document.querySelector('.aur-live-reviews__grid');
        if (!grid) return;

        var cards = getAuroreReviewCards();
        var sortedCards = cards.sort(function (a, b) {
          if (event.currentTarget.value === 'highest') {
            return Number(b.dataset.rating || 0) - Number(a.dataset.rating || 0);
          }
          return Number(b.dataset.date || 0) - Number(a.dataset.date || 0);
        });

        sortedCards.forEach(function (card) { grid.appendChild(card); });
        applyAuroreReviewFilters();
      });
    }

    var loadMoreButton = document.querySelector('[data-aurore-load-more-reviews]');
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', function (event) {
        var cards = getAuroreReviewCards();
        cards.filter(function (card) { return card.hidden; }).slice(0, 6).forEach(function (card) {
          card.hidden = false;
        });
        if (!cards.some(function (card) { return card.hidden; })) {
          var actions = event.currentTarget.closest('.aur-live-reviews__actions');
          if (actions) actions.remove();
        }
      });
    }

    if (document.querySelector('[data-review-card]')) return;

    var readText = function (node, selector) {
      var value = node.querySelector(selector);
      return value ? value.textContent.replace(/\s+/g, ' ').trim() : '';
    };

    var appendText = function (parent, tagName, className, text) {
      if (!text) return null;
      var element = document.createElement(tagName);
      element.className = className;
      element.textContent = text;
      parent.appendChild(element);
      return element;
    };

    var createReviewCard = function (review) {
      var card = document.createElement('article');
      card.className = 'aur-live-review-card';

      var date = readText(review, '.jdgm-rev__timestamp, .jm-review__date');
      var title = readText(review, '.jdgm-rev__title, .jm-review__title');
      var body = readText(review, '.jdgm-rev__body, .jm-review__body');
      var author = readText(review, '.jdgm-rev__author, .jm-review__author') || 'Verified customer';
      var product = readText(review, '.jdgm-rev__prod-link, .jm-product-variant-card, .jm-review__product-title');

      var top = document.createElement('div');
      top.className = 'aur-live-review-card__top';
      appendText(top, 'span', 'aur-live-review-card__stars', '★★★★★');
      appendText(top, 'span', 'aur-live-review-card__date', date);
      card.appendChild(top);

      appendText(card, 'h2', 'aur-live-review-card__title', title);
      appendText(card, 'p', 'aur-live-review-card__body', body);
      appendText(card, 'p', 'aur-live-review-card__author', author + ' — Verified Buyer');

      if (product) {
        var verified = document.createElement('p');
        verified.className = 'aur-live-review-card__verified';
        appendText(verified, 'span', '', '✓ Verified Purchase');
        appendText(verified, 'span', 'aur-live-review-card__product', product);
        card.appendChild(verified);
      }

      return card;
    };

    var getReviews = function () {
      return Array.from(document.querySelectorAll('.jdgm-rev, .jm-review-card, .jm-review'))
        .filter(function (review) { return readText(review, '.jdgm-rev__body, .jm-review__body'); });
    };

    var buildReviewsPage = function () {
      if (document.documentElement.dataset.auroreReviewsBuilt === 'true') return true;

      var reviews = getReviews();
      if (!reviews.length) return false;

      var target = document.querySelector('[data-aurore-live-reviews]');
      var summary = document.querySelector('.aur-reviews-page__summary');
      var widget = document.querySelector('.jdgm-rev-widg, .jdgm-all-reviews-widget, .jdgm-widget');

      if (!target) {
        target = document.createElement('div');
        target.className = 'aur-live-reviews';
        target.setAttribute('data-aurore-live-reviews', '');

        if (summary) {
          summary.insertAdjacentElement('afterend', target);
        } else if (widget && widget.parentElement) {
          widget.parentElement.insertBefore(target, widget);
        } else {
          var main = document.querySelector('#MainContent');
          if (main) main.appendChild(target);
        }
      }

      target.innerHTML = '';

      var grid = document.createElement('div');
      grid.className = 'aur-live-reviews__grid';

      var cards = reviews.map(createReviewCard);
      cards.forEach(function (card, index) {
        if (index >= 6) card.hidden = true;
        grid.appendChild(card);
      });

      target.appendChild(grid);

      if (cards.length > 6) {
        var actions = document.createElement('div');
        actions.className = 'aur-live-reviews__actions';

        var button = document.createElement('button');
        button.className = 'aur-live-reviews__button';
        button.type = 'button';
        button.textContent = 'LOAD MORE REVIEWS';
        button.addEventListener('click', function () {
          cards.filter(function (card) { return card.hidden; }).slice(0, 6).forEach(function (card) {
            card.hidden = false;
          });
          if (!cards.some(function (card) { return card.hidden; })) actions.remove();
        });

        actions.appendChild(button);
        target.appendChild(actions);
      }

      document.querySelectorAll('.jdgm-rev-widg, .jdgm-all-reviews-widget, .jdgm-widget').forEach(function (node) {
        if (!node.closest('[data-aurore-live-reviews]')) node.setAttribute('hidden', '');
      });

      document.documentElement.dataset.auroreReviewsBuilt = 'true';
      document.body.classList.add('page-reviews', 'aur-reviews-page--enhanced');
      return true;
    };

    if (buildReviewsPage()) return;

    var observer = new MutationObserver(function () {
      if (buildReviewsPage()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(buildReviewsPage, 800);
    window.setTimeout(buildReviewsPage, 1600);
    window.setTimeout(buildReviewsPage, 3200);
    window.setTimeout(buildReviewsPage, 5000);
  });
})();
